import React, { useState } from 'react';
import { createUserWithEmailAndPassword, getAuth } from 'firebase/auth';
import { doc, getDoc, getFirestore, setDoc, updateDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

const friendlySignupError = (error) => {
  if (error.code === 'auth/email-already-in-use') return 'An account already exists for this email. Try signing in instead.';
  if (error.code === 'auth/weak-password') return 'Choose a password with at least six characters.';
  if (error.code === 'auth/invalid-email') return 'Enter a valid email address.';
  return 'We could not create your account. Please try again.';
};

function SignUpComponent({ onSubmittingChange }) {
  const auth = getAuth();
  const db = getFirestore();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', location: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const updateField = (event) => setForm((current) => ({ ...current, [event.target.name]: event.target.value }));

  const handleSignUp = async (event) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    onSubmittingChange?.(true);
    try {
      const counterDoc = doc(db, 'counters', 'lastUserId');
      const counterSnapshot = await getDoc(counterDoc);
      if (!counterSnapshot.exists()) throw new Error('profile-counter-unavailable');
      const newUserId = counterSnapshot.data().value + 1;
      await updateDoc(counterDoc, { value: newUserId });

      const userCredential = await createUserWithEmailAndPassword(auth, form.email.trim(), form.password);
      const user = userCredential.user;
      await setDoc(doc(db, 'users', user.uid), {
        uid: user.uid,
        userId: newUserId,
        name: form.name.trim(),
        email: user.email,
        location: form.location.trim(),
        imageUrl: '',
        goals: '',
      });
      navigate(`/UserProfile/${newUserId}`);
    } catch (signupError) {
      console.error('Error signing up:', signupError);
      setError(friendlySignupError(signupError));
    } finally {
      setSubmitting(false);
      onSubmittingChange?.(false);
    }
  };

  return (
    <form className="auth-form" onSubmit={handleSignUp}>
      {error && <div className="auth-error" role="alert">{error}</div>}
      <div className="auth-field-row">
        <label className="auth-field"><span>Name</span><input name="name" value={form.name} onChange={updateField} placeholder="Your full name" autoComplete="name" required /></label>
        <label className="auth-field"><span>Home base</span><input name="location" value={form.location} onChange={updateField} placeholder="City or mountain region" autoComplete="address-level2" /></label>
      </div>
      <label className="auth-field"><span>Email</span><input name="email" type="email" value={form.email} onChange={updateField} placeholder="you@example.com" autoComplete="email" required /></label>
      <label className="auth-field"><span>Password</span><input name="password" type="password" value={form.password} onChange={updateField} placeholder="At least 6 characters" minLength="6" autoComplete="new-password" required /></label>
      <label className="auth-consent"><input type="checkbox" required /><span>I agree to climb responsibly and follow the ClimberLink community guidelines.</span></label>
      <button className="auth-submit" type="submit" disabled={submitting}>{submitting ? 'Building your profile…' : 'Create my profile'}</button>
      <p className="auth-legal">By joining, you agree to ClimberLink’s Terms of Service and Privacy Policy.</p>
    </form>
  );
}

export default SignUpComponent;
